import { render, staticRenderFns } from "./homeCn.vue?vue&type=template&id=b61288ca&scoped=true&"
import script from "./homeCn.vue?vue&type=script&lang=js&"
export * from "./homeCn.vue?vue&type=script&lang=js&"
import style0 from "./homeCn.vue?vue&type=style&index=0&id=b61288ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61288ca",
  null
  
)

export default component.exports